import { ApiSlugs, FileId, FileSummaryDto, ListPagination } from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../../../api-caller.service';
import { ApiConnector } from '../../../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../../../utils/query-params.utils';

export class UserFilesAdminConnector extends ApiConnector<FileSummaryDto, FileSummaryDto, FileId> {
  constructor(apiCaller: ApiCaller, userUrl: string, apiPrefix: string) {
    super(apiCaller, apiPrefix, `${userUrl}/${ApiSlugs.FILES}`);
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<FileSummaryDto[]> =>
      this.apiCaller.getRequest<FileSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
